export enum TYPE_VALUE_FORM {
  TEXT = 'text',
  DATE = 'date',
  PASSWORD = 'password',
  EMAIL = 'email',
  COLOR = 'color',
  NUMBER = 'number',
  TIME = 'time',
  WEEK = 'week'
}
